module.exports = __webpack_public_path__ + "static/img/james.6955493f.jpg";